import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Grid, Skeleton } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`
  },

  chartContainer: {
    margin: theme.spacing(1),
    height: theme.spacing(8),
    overflow: 'hidden',
    backgroundColor: theme.skelton.color,
    borderRadius: theme.spacing(0.5)
  },

  skeleton: {
    backgroundColor: theme.skelton.color,
    width: '1%'
  }
}));

const BubbleChartSkeleton: React.FC = () => {
  const classes = useStyles();
  return (
    <Grid container data-testid="keyword_cloud_skeleton_container">
      <Grid container item xs={12} className={classes.chartContainer}>
        <Skeleton
          height="70%"
          variant="rectangular"
          data-testid="keyword-cloud-skeleton"
        />
      </Grid>
    </Grid>
  );
};

export default React.memo(BubbleChartSkeleton);
